import { useTranslation } from "react-i18next"
export const NoDataFound = () => {
 // language translator
 const { t } = useTranslation("translation")
 return (
  <div className="w-full mx-auto text-center">
   <div className="text-2xl text-dark-black pt-5 pb-2">{t("noDataFound")}</div>
  </div>
 )
}
